import moment from 'moment';
import { formConfig } from '../../../config';
import { fromDateStr } from '../../../../../../../helpers/utcDate';

const { workersSetFieldNames, docFieldNames } = formConfig;

const addressNames = new Set(Object.values(workersSetFieldNames));
const docNames = new Set(Object.values(docFieldNames));

const transformDocDataFns = {
  [docFieldNames.docDate]: (value) =>
    !moment.isMoment(value) ? value : fromDateStr(value),

  [docFieldNames.docType]: (value) =>
    value === null || isNaN(Number(value)) ? value : Number(value),
};

export const transformValues = ({
  values,
  needAddressValues,
  needWarrantyDocValues,
}) => {
  return Object.entries(values).reduce((acc, [key, value]) => {
    if (needAddressValues && addressNames.has(key)) {
      acc.addressValues = acc.addressValues || {};
      acc.addressValues[key] = value;
    }

    if (needWarrantyDocValues && docNames.has(key)) {
      acc.warrantyDocValues = acc.warrantyDocValues || {};
      acc.warrantyDocValues[key] =
        typeof transformDocDataFns[key] === 'function'
          ? transformDocDataFns[key](value)
          : value;
    }

    return acc;
  }, {});
};

export const getInitValForWorkersField = ({ entities, entity }) => {
  if (!entity) return entities.find((item) => item.autoSet)?.id;

  let currentEntity;

  for (let item of entities) {
    if (item.autoSet) {
      currentEntity = item.id;
      break;
    }

    if (item.id === entity.id) {
      currentEntity = entity.id;
      break;
    }
  }

  return currentEntity;
};
